import type { Testimonial } from '../testimonials'

export const added: Testimonial = {
  company: 'Hopi',
  logo: { name: 'Hopi', src: '/logo/hopi.webp' },
  portrait: { src: '/photo/portrait-gul-sagir-aydin.png', alt: 'Gül Sağır Aydın' },
  quote: [
    'As Hopi, our challenge was to design a pathway for our sustainability ambitions and '
    + 'linking it to the Boyner Group agenda. We decided to first measure our score within 6 '
    + 'dimensions to have the holistic view on such an exciting and existential journey. The '
    + 'assesment resulted in many initiatives and recommendations that we can easily embark '
    + 'on. We will continue Spreading our company’s intentions to our partners and ecosystem '
    + 'to create new collective platforms or initiatives aligned with specific some SDGs we '
    + 'prioritised.',
  ],
  attribution: 'Gül Sağır Aydın, Chief Consumer Business Officer',
}

/** Its place on the wall — the order the live page lists them in. */
export const order = 16
